import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './net/index'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Vant from 'vant';
import 'vant/lib/index.css';

import until from './until/until'
import './mixins/mixins'


Vue.prototype.$until = until;
Vue.use(ElementUI);
Vue.use(Vant);
Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')